import { Route } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { subscriptionGuard } from './guards/subscription.guard';
import { logoutGuard } from './guards/logout.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/login', pathMatch: 'full' }, // redirect to `login`
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'delivery-schedule',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/delivery-schedule/delivery-schedule.component').then(
        (m) => m.DeliveryScheduleComponent,
      ),
  },
  {
    path: 'referral',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/my-referral/my-referral.component').then(
        (m) => m.MyReferralComponent,
      ),
  },
  {
    path: 'free-boxes',
    canActivate: [authGuard, subscriptionGuard],
    loadComponent: () =>
      import('./components/free-meals/free-meals.component').then(
        (m) => m.FreeMealsComponent,
      ),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/my-account/my-account.component').then(
        (m) => m.MyAccountComponent,
      ),
  },
  {
    path: 'subscription',
    canActivate: [authGuard, subscriptionGuard],
    loadComponent: () =>
      import('./components/subscription-settings/subscription-settings.component').then(
        (m) => m.SubscriptionSettingsComponent,
      ),
  },
  {
    path: 'subscription/update-delivery-frequency',
    canActivate: [authGuard, subscriptionGuard],
    loadComponent: () =>
      import('./components/update-delivery-frequency/update-delivery-frequency.component').then(
        (m) => m.UpdateDeliveryFrequencyComponent,
      ),
  },
  {
    path: 'wallets',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/wallets/wallets.component').then(
        (m) => m.WalletsComponent,
      ),
  },
  {
    path: 'my-orders',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/my-orders/my-orders.component').then(
        (m) => m.MyOrdersComponent,
      ),
  },
  {
    path: 'order-details/:orderId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/order-details/order-details.component').then(
        (m) => m.OrderDetailsComponent,
      ),
  },
  {
    path: 'thank-you/:orderId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/thank-you/thank-you.component').then(
        (m) => m.ThankYouComponent,
      ),
  },
  {
    path: 'donations',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/donation/donation.component').then(
        (m) => m.DonationComponent,
      ),
  },
  {
    path: 'change-subscription',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/cancel-subscription/cancel-subscription.component').then(
        (m) => m.CancelSubscriptionComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./components/change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent,
      ),
  },
  {
    path: 'my-ratings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/my-ratings/my-ratings.component').then(
        (m) => m.MyRatingsComponent,
      ),
  },
  // Legacy `/logout` link target; the guard logs out and redirects.
  { path: 'logout', canActivate: [logoutGuard], children: [] },
  { path: '**', redirectTo: '/login' },
];
